import ListItemText from "@material-ui/core/ListItemText";
import { ListItemButton, ListItemIcon } from "@mui/material";
import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';

const ListItemLinks = ({
  depth,
  title,
  to,
  isMain,
  isSelected,
  manualId,
  onClick,
  hash,
  onSelected
}) => {
  const [selected, setSelected] = useState(isSelected)

  const handleSetSelected = async (event) => {
    if (!isMain) {
      event.preventDefault()
      onSelected(to)
    }

  }

  useEffect(() => {
    if (!isMain) {
      setSelected(isSelected)
    }
  }, [isSelected, isMain]);

  return (
    <ListItemButton
      selected={selected}
      onClick={onClick ? onClick : handleSetSelected}
      to={to}
      component={isMain ? Link : 'a'}
      className={`depth-${depth}`}
    >
      <ListItemText primary={title} data-depth={depth} />
      <ListItemIcon>
        <ArrowForwardIosOutlinedIcon />
      </ListItemIcon>
    </ListItemButton>
  )

}

export default ListItemLinks
